import { withBase } from 'ufo'
import { tutorialVideoSchema, tutorialVideosSchema } from '~/utils/crystallize/tutorial-video'

const ROOT_PATH = '/hjelpevideoer'

export function useTutorialVideos() {
  const options = useCatalogueQueryOptions({
    path: ROOT_PATH,
    schema: tutorialVideosSchema,
  })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}

export function useTutorialVideo(slug: MaybeRef<string>) {
  const path = computed(() => withBase(toValue(slug), ROOT_PATH))

  const options = useCatalogueQueryOptions({
    path,
    schema: tutorialVideoSchema,
  })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
